// extracted by mini-css-extract-plugin
export default {"root":"SortingArea_root__3V-TJ"};